<template>
  <div>
    <v-card
      class="elevation-2"
      style="border-radius: 8px"
    >
      <v-layout
        align-center
        justify-space-around
        column
        fill-height
      >
        <v-card-text class="pa-4">
          <v-flex class="text-left">
            <div v-if="showProgress">
              <v-spacer></v-spacer>
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <h4 class="mb-2">{{ locale[local].screen.login.form1.title }}</h4>
            <p>
              {{ locale[local].screen.login.form1.label }}
            </p>
            <v-divider></v-divider>
          </v-flex>
          <v-flex>
            <v-form
              ref="form"
              v-on:submit.prevent="logar"
            >
              <v-text-field
                name="cpf"
                label="CPF"
                type="text"
                v-model="cpf"
                return-masked-value
                v-mask="mask"
                :rules="cpfRules"
                prepend-icon="mdi-account-box"
              ></v-text-field>
              <v-text-field
                v-if="showSenha"
                name="senha"
                v-model="senha"
                :label="locale[local].screen.login.form1.passwordLabel"
                type="password"
                :rules="senhaRules"
                prepend-icon="mdi-lock-question"
              ></v-text-field>
              <v-checkbox
                v-model="lembrarme"
                :label="locale[local].screen.login.form1.rememberLabel"
              ></v-checkbox>
              <v-btn
                block
                color="primary"
                class="mt-2"
                @click="logar"
              >{{
                locale[local].screen.login.form1.btnLoginLabel
              }}</v-btn>
            </v-form>
          </v-flex>
        </v-card-text>
      </v-layout>
    </v-card>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          <v-spacer></v-spacer>
          {{locale[local].screen.login.dialog1.title}}
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="pt-1">
          <br>
 

          {{ dialogMessage }}

          <div v-if="dialogMessage1 && isIcon">
            <br>

            <strong>{{ dialogMessage1 }}</strong>

            <br>
            <br>
            <br>

          </div>

          <br v-if="this.enviar" /><br v-if="this.enviar" />

          <span v-if="this.enviar"> {{ dialogMessageTelefone }} </span>

          <br v-if="this.enviar" /><br v-if="this.enviar" />

          <span v-if="this.enviar"> ou </span>

          <br v-if="this.enviar" /><br v-if="this.enviar" />

          <span v-if="this.enviar"> {{ dialogMessageEmail }} </span>

          <br v-if="this.enviar" /><br v-if="this.enviar" />

          <span v-if="this.enviar">
            {{ locale[local].screen.login.dialog1.askMessagePassword }}
          </span>

          <v-row justify="space-around">
            <v-radio-group
              v-model="metodoRecuperacao"
              row
              v-if="this.enviar"
            >
              <v-radio
                label="WhatsApp"
                value="1"
                color="primary"
                :disabled="!temFone"
              ></v-radio>
              <!-- :disabled="!temFone" -->
              <v-radio
                label="E-mail"
                value="2"
                :disabled="!temEmail"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-row>

          <v-flex v-show="solicitaEmail">
            <v-form
              id="formEmail"
              ref="formEmail"
              v-model="valid"
              lazy-validation
              v-on:submit.prevent="enviarEmail"
            >
              <v-text-field
                name="email"
                label="E-mail"
                type="email"
                v-model="email"
                :rules="[emailRules.required, emailRules.emailValido]"
                prepend-icon="mdi-email"
                required
              ></v-text-field>
            </v-form>
          </v-flex>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions v-if="!enviar">
          <v-btn
            v-if="sms"
            color="primary"
            text
            @click="esqueceuSenha"
          >{{
            locale[local].screen.login.dialog1.btnChangePasswordLabel
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
           :block="!sms"
            color="primary"
            :text="sms"
            @click="dialog = false"
            ref="btnOk"
          >OK</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn
            v-if="sms"
            color="primary"
            text
           
            @click="
              dialog = false;
              enviar = false;
            "
          >{{ locale[local].screen.login.dialog1.btnCancelLabel }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            :disabled="loading || metodoRecuperacao < 1"
            color="primary"
            text
            @click="enviarRecuperacaoSenha"
          >{{ locale[local].screen.login.dialog1.btnSendLabel }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="passwordDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline primary"
          style="color: white"
          primary-title
        >{{ locale[local].screen.login.dialog2.title }}
        </v-card-title>

        <v-card-text class="py-3">
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              class="pt-4"
            >
              <h3>
                {{ locale[local].screen.login.dialog2.message }}
              </h3>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-text class="py-3">
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              class="pt-4"
            >
              <v-form ref="formSenha">
                <v-text-field
                  dense
                  v-model="novaSenha"
                  :label="
                    locale[local].screen.login.dialog2.btnNewPasswordLabel
                  "
                  filled=""
                  :rules="
                    this.$senhaApenasNumerica ? senhaNumericaRules : senhaRules
                  "
                  counter="6"
                  required
                  :append-icon="senhaVisivel ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (senhaVisivel = !senhaVisivel)"
                  :type="senhaVisivel ? 'password' : 'text'"
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="passwordDialog = false"
          >{{
            locale[local].screen.login.dialog2.btnCancelLabel
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="alteraSenha"
          >{{
            locale[local].screen.login.dialog2.btnUpdateLabel
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="8000"
      :vertical="false"
    >
      {{ mensagem }}
      <v-btn
        color="red"
        text
        @click="snackbar = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Home from "../views/Home";
import Service from "@/components/api/Service.js";
import { locale } from "../locale/locale";
export default {
  components: {},
  computed: {
    isIcon() {
      return process.env.VUE_APP_CLIENTE === 'ICON'
    }
  },
  data: (vm) => ({
    lembrarme: false,
    enviar: false,
    valid: false,
    cpfRules: [(v) => !!v || locale[window.local].rules.cpfLabel],
    senhaRules: [(v) => !!v || locale[window.local].rules.passwordLabel],
    emailRules: {
      required: (v) => !!v || locale[window.local].rules.emailLabel,
      emailValido: (v) =>
        vm.validarEmail(v) || locale[window.local].rules.emailLabelInvalid,
    },
    confirmacao: null,
    dialog: false,
    passwordDialog: false,
    dialogMessage: "",
    dialogMessage1: "",
    service: new Service(),
    showSenha: false,
    senha: null,
    mask: "###.###.###-##",
    cpf: null,
    print: console.log,
    codPessoa: 0,
    codCli: 0,
    codEmp: 0,
    showProgress: false,
    verifyed: false,
    sms: false,
    telefone: null,
    email: null,
    loading: false,
    snackbar: false,
    mensagem: "",
    solicitaEmail: false,
    temFone: false,
    temEmail: false,
    metodoRecuperacao: 0,
    senhaVisivel: true,
    novaSenha: null,
    senhaRules: [(v) => !!v || locale[window.local].rules.passwordLabel],
    senhaNumericaRules: [
      (v) => !!v || locale[window.local].rules.passwordLabel,
      (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0) return true;
        return locale[window.local].rules.passwordLabelJustNumbers;
      },
      (v) =>
        vm.validaNumerosIguaisSeguidos(v) ||
        locale[window.local].rules.passwordLabel2EqualNumbers,
      (v) =>
        vm.validaNumerosSequencias(v) ||
        locale[window.local].rules.passwordLabel3EqualNumbers,
      ,
      (v) =>
        (v && v.length == 6) ||
        locale[window.local].rules.passwordMin6Characteres,
    ],
  }),
  async mounted() {
    if (sessionStorage.getItem("lembrarme") === "true") {
      this.cpf = localStorage.getItem("cpf");
      this.lembrarme = true;
    }
  },
  methods: {
    onVerify() {
      this.verifyed = true;
    },
    onExpired() {
      this.verifyed = false;
    },
    validarEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
      return re.test(email);
    },
    async enviarMSG() {
      this.loading = true;

      let response = await this.service.enviaWhatsApp(this.codPessoa, this.telefone);

      if (response.data.retorno[0].estatus === "Sucesso") {
        this.dialogMessage = locale[window.local].screen.login.dialog1.smsOK;
      } else {
        this.dialogMessage = locale[window.local].screen.login.dialog1.smsError;
      }

      this.sms = false;
      this.enviar = false;

      this.loading = false;
    },
    async enviarEmail() {
      try {
        this.$refs.formEmail.validate();

        if (this.email) {
          this.loading = true;

          let response = await this.service.enviaEmail(
            this.codPessoa,
            this.email
          );

          if (response.data.retorno[0].msgErro.split(" - ")[0] === "1") {
            this.dialogMessage =
              locale[window.local].screen.login.dialog1.emailOK;
          } else {
            this.dialogMessage =
              locale[window.local].screen.login.dialog1.emailError;
          }

          this.sms = false;
          this.enviar = false;
          this.solicitaEmail = false;
          this.loading = false;
        }
      } catch (e) {
        this.mensagem = e;
        this.snackbar = true;
        this.loading = false;
      }
    },
    async enviarRecuperacaoSenha() {
      if (this.metodoRecuperacao == 1) {
        this.enviarMSG();
      } else if (this.metodoRecuperacao == 2) {
        this.enviarEmail();
      }
    },
    async esqueceuSenha() {
      try {
        this.loading = false;
        let response = await this.service.esqueceuSenha(this.codPessoa);

        if (response.data.retorno[0].estatus === "Sucesso") {
          var retornos = response.data.retorno[0].msgErro.split(";");
          retornos[0] = retornos[0].split(" - ")[1];

          if (retornos[0] === "0" && retornos[2] === "0") {
            this.dialogMessage = locale[window.local].screen.login.dialog1.emailAndNumberNotFound;
            this.dialogMessageTelefone = "";
            this.dialogMessageEmail = "";
            this.enviar = false;
            this.temFone = false;
            this.temEmail = true;
            this.telefone = "";
            this.email = "";
          } else {
            this.dialogMessage = locale[window.local].screen.login.dialog1.passwordOptionsRecovery;

            if (retornos[0] === "0") {
              this.dialogMessageTelefone = locale[window.local].screen.login.dialog1.phoneNotValid;
              this.temFone = false;
              
              if (retornos[1] != "0") {
                this.dialogMessageTelefone = locale[window.local].screen.login.dialog1.smsNumber + retornos[1];
                this.telefone = retornos[0].split(" - ")[1];
              } else {
                this.telefone = "";
              }
              
            } else {
              if (retornos[1] === "0") {
                this.dialogMessageTelefone = locale[window.local].screen.login.dialog1.smsNumber +
                                             locale[window.local].screen.login.dialog1.noSmsNumber;
              } else {
                this.dialogMessageTelefone = locale[window.local].screen.login.dialog1.smsNumber + retornos[1];
              }
              this.temFone = true;
              this.telefone = retornos[0].split(" - ")[1];
            }

            if (retornos[2] === "0") {
              this.dialogMessageEmail = locale[window.local].screen.login.dialog1.emailNotFound;
              this.temEmail = false;
              this.email = "";
            } else {
              this.dialogMessageEmail = locale[window.local].screen.login.dialog1.emailNumber + retornos[3];
              this.temEmail = true;
              this.email = retornos[2];
            }

            this.enviar = true;
          }
        } else {
          this.mensagem = response.data.retorno[0].msgErro;
          this.snackbar = true;
        }
      } catch (e) {
        this.mensagem = e.toString();
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },

    async alteraSenha() {
      if (this.$refs.formSenha.validate()) {
        var response = await this.service.alterarSenhaLogin(
          this.novaSenha,
          this.codPessoa
        );
        if (response.data.retorno[0].estatus === "Sucesso") {
          this.passwordDialog = false;

          response = await this.service.validaSenha({
            codPessoa: this.codPessoa,
            senha: this.novaSenha,
          });

          if (response.data.retorno) {
            if (response.data.retorno[0].estatus === "Sucesso") {
              localStorage.setItem("codEmp", this.codEmp);
              localStorage.setItem("codPessoa", this.codPessoa);
              localStorage.setItem("nomePessoa", this.nomePessoa);
              localStorage.setItem("codCli", this.codCli);
              localStorage.setItem("cpf", this.cpf);
              localStorage.setItem("hash", btoa(this.novaSenha));
              sessionStorage.setItem("lembrarme", this.lembrarme);

              sessionStorage.setItem("logado", true);

              this.$emit("home", Home);
            }
          }
        }
      }
    },

    validaNumerosIguaisSeguidos(novaSenha) {
      for (let i = 0; i < novaSenha.length - 1; i++) {
        if (novaSenha[i] === novaSenha[i + 1]) {
          return false;
        }
      }
      return true;
    },
    validaNumerosSequencias(novaSenha) {
      for (let i = 0; i < novaSenha.length - 2; i++) {
        if (
          parseInt(novaSenha[i]) + 1 === parseInt(novaSenha[i + 1]) &&
          parseInt(novaSenha[i]) + 2 === parseInt(novaSenha[i + 2])
        ) {
          return false;
        }
      }
      return true;
    },

    async logar() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          var response;

          if (this.showSenha) {
            response = await this.service.validaSenha({
              codPessoa: this.codPessoa,
              senha: this.senha,
            });

            if (response.data.retorno) {
              if (response.data.retorno[0].estatus === "Sucesso") {
                localStorage.setItem("codEmp", this.codEmp);
                localStorage.setItem("codPessoa", this.codPessoa);
                localStorage.setItem("codCli", this.codCli);
                localStorage.setItem("cpf", this.cpf);
                localStorage.setItem("nomePessoa", this.nomePessoa);
                localStorage.setItem("hash", btoa(this.senha));
                sessionStorage.setItem("lembrarme", this.lembrarme);

                sessionStorage.setItem("logado", true);

                this.$emit("home", Home);
              } else 
              if (response.data.retorno[0].estatus === "Ja e empregado") {
                if (
                  response.data.retorno[0].msgErro.split(" - ").length === 3
                ) {
                  if (
                    response.data.retorno[0].msgErro.split(" - ")[0] === "4"
                  ) {
                    this.dialog = true;
                    this.dialogMessage =
                      response.data.retorno[0].msgErro.split(" - ")[2] +
                      ". " +
                      locale[local].screen.login.contact;
                  }
                }
              } else 
              if (response.data.retorno[0].estatus === "Senha incorreta") {
                this.dialog = true;
                this.sms = true;
                this.dialogMessage = locale[local].screen.login.dialog1.wrongPass;
                this.dialogMessage1 = locale[local].screen.login.dialog1.wrongPass1;
              } else 
              if (response.data.retorno[0].estatus === "Trocar Senha") {
                localStorage.setItem("codPessoa", this.codPessoa);
                localStorage.setItem("hash", btoa(this.senha));
                this.passwordDialog = true;
              }
            } else {
              if (response.data.logErroApp) {
                this.dialog = true;
                this.dialogMessage =
                  locale[local].screen.login.dialog1.wrongLogin +
                  "Erro :" +
                  response.data.logErroApp[0].erro;
              }
            }
          } else {
            response = await this.service.validaCPF({ cpf: this.cpf });

            if (response.data.retorno[0].estatus === "Sucesso") {
              this.showSenha = true;

              const [empresa, pessoa, nome, codCli] =
                response.data.retorno[0].msgErro.split(" - ");
              this.codEmp = parseInt(empresa);
              this.codPessoa = parseInt(pessoa);
              this.codCli = parseInt(codCli);
              this.nomePessoa = nome;
            } else if (
              response.data.retorno[0].estatus === "CPF não encontrado" ||
              response.data.retorno[0].estatus === "Empregado nao encontrado"
            ) {
              this.dialog = true;
              this.dialogMessage =
                locale[local].screen.login.dialog1.cpfNotFound;
            } else if (
              response.data.retorno[0].estatus === "Sucesso sem senha"
            ) {
              this.dialog = true;
              this.dialogMessage =
                locale[local].screen.login.dialog1.passNotFound;
            } else if (
              response.data.retorno[0].estatus ===
              "Não tem vinculo de colaborador"
            ) {
              this.dialog = true;
              this.dialogMessage =
                locale[local].screen.login.dialog1.personNotFound;
            }
          }
        } catch (e) {
          this.mensagem = locale[local].screen.login.serviceNotFound;
          this.snackbar = true;
          this.loading = false;
        } finally {
          this.setaFocusBtnOK();
        }
      }
    },
    setaFocusBtnOK() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.btnOk.$el.focus();
        });
      });
    },
  },
  props: {
    source: String,
    tipo: String,
    codVaga: Number,
  },
};
</script>
